import React, {useEffect} from 'react';
import {Row, Button, Col} from 'react-bootstrap';
import styles from './investor-details.module.scss';
import {
  CurrencyInput,
  DateInput, DropDown,
  FormGroup,
  RadioButton, RadioTextInput,
  TextInput
} from "../../../../../components/form/form";
import {useValidation} from "../../../../../hooks/use-validation";
import {
  investorDetailsObj,
  investorDetailsValidator
} from "../../../../../form-control/registration-form/investor-details-form-control";
import {getOrganizationType, getRegistrationInvestorCategory} from "../../../../../helpr/registrationFormData";
import {getCountries, getGenericSalutationTypes, getGenericYesOrNo} from "../../../../../helpr/genericFormData";

const InvestorDetails = ({context, controls}) => {
  //Unpack trade form main context
  const { initialRegistrationInfoState, registrationFormState, setRegistrationFormState } = context;
  const { next } = controls;

  //Setup validator and transfer instruction state
  const investorDetailsState = useValidation(
    investorDetailsValidator,
    investorDetailsObj(registrationFormState),
    {border: '1px solid red'});
  const { validate, getTextFieldProps, getRadioButtonProps, getDropdownProps, forceSetField, getField } = investorDetailsState;

  //Setup initial trade info
  useEffect(() => {
    forceSetField('securityId', initialRegistrationInfoState.securityId);
    forceSetField('faceAmount', initialRegistrationInfoState.faceAmount.toString());
    forceSetField('settlementDate', initialRegistrationInfoState.settlementDate);
  }, []);

  const nextPage = () => {
    const { formState, isFormValid } = validate();
    console.log(formState, isFormValid);
    if(isFormValid){
      const investorData = {}
      if(formState.investorCategoryType === 'INDV') {
        investorData['investorCategory'] = {
          type: formState.investorCategoryType,
          under: ''
        }
        investorData['investor'] = `${formState.investorIndividualFirstName} ${formState.investorIndividualMiddleName}
          ${formState.investorIndividualLastName}`
        investorData['investorIndividual'] = {
          salutation: formState.investorIndividualSalutation,
          lastName: formState.investorIndividualLastName,
          firstName: formState.investorIndividualFirstName,
          middleName: formState.investorIndividualMiddleName
        }
        investorData['nationality'] = formState.nationality
        investorData['usCitizen'] = formState.usCitizen
        investorData['usResident'] = formState.usResident
        investorData['usResidentCard'] = formState.usResidentCard
        investorData['parentCompany'] = ''
        investorData['organizationType'] = ''
      }
      else if(formState.investorCategoryType === 'CORP') {
        investorData['investorCategory'] = {
          type: formState.investorCategoryType,
          under: formState.investorCategoryUnder
        }
        investorData['investor'] = formState.investor
        investorData['investorIndividual'] = {
          salutation: '',
          lastName: '',
          firstName: '',
          middleName: ''
        }
        investorData['nationality'] = ''
        investorData['usCitizen'] = ''
        investorData['usResident'] = ''
        investorData['usResidentCard'] = ''
        investorData['parentCompany'] = formState.parentCompany
        investorData['organizationType'] = formState.organizationType
      }
      setRegistrationFormState({
        ...registrationFormState,
        securityId: formState.securityId,
        faceAmount: formState.faceAmount,
        settlementDate: formState.settlementDate,
        dateBirthIncorporation: formState.dateBirthIncorporation,
        placeBirthIncorporation: formState.placeBirthIncorporation,
        domicile: formState.domicile,
        ...investorData
      });
      next();
    }
  }

  const renderInvestorFields = () => {
    return getField('investorCategoryType') === 'INDV' ? (
      <>
        <Row>
          <Col lg={12}>
            <div>
              Name:*
            </div>
          </Col>
          <Col lg={3}>
            <TextInput inputProps={getTextFieldProps('investorIndividualLastName')} placeholder={"Last Name"}>
            </TextInput>
          </Col>
          <Col lg={3}>
            <TextInput inputProps={getTextFieldProps('investorIndividualFirstName')} placeholder={"First Name"}>
            </TextInput>
          </Col>
          <Col lg={3}>
            <TextInput inputProps={getTextFieldProps('investorIndividualMiddleName')} placeholder={"Middle Initial"}>
            </TextInput>
          </Col>
        </Row>
        <Row>
          <Col lg={5}>
            <RadioButton inputProps={getRadioButtonProps('investorIndividualSalutation')}
                         data={getGenericSalutationTypes()} othersOption={false}>
              Salutation:*
            </RadioButton>
          </Col>
        </Row>
      </>
    ) : getField('investorCategoryType') === 'CORP' ? (
      <Row>
        <Col lg={5}>
          <TextInput inputProps={getTextFieldProps('investor')} placeholder={""}>
            Business Name:*
          </TextInput>
        </Col>
      </Row>
    ) : ''
  }

  return (
    <div className={styles['form-section']} >
      <Row>
        <Col lg={12}>
          <FormGroup header={'SECURITY INFORMATION'}>
            <Row>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('securityId')} placeholder={""}>
                  Security ID/ISIN No.:*
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <CurrencyInput inputProps={getTextFieldProps('faceAmount')} placeholder={"In Figures"}>
                  Face Amount:*
                </CurrencyInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <div className={styles['in-words']}>
                  <input type='text' disabled={true} placeholder={'In Words'}/>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={12}>
                <div className={styles['section-spacing']}>
                </div>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <DateInput inputProps={getTextFieldProps('settlementDate')}>
                  Settlement Date:*
                </DateInput>
              </Col>
            </Row>
          </FormGroup>
          <FormGroup header={'INVESTOR DETAILS'}>
            <Row>
              <Col lg={5}>
                <RadioTextInput header={"Type of Investor:*"} inputProps={getRadioButtonProps('investorCategoryType')} data={getRegistrationInvestorCategory()} noOptionIndexes={[0]}>
                  <TextInput inputProps={getRadioButtonProps('investorCategoryUnder')} placeholder="Under the laws of"/>
                </RadioTextInput>
              </Col>
            </Row>
            {renderInvestorFields()}
            <Row>
              <Col lg={5}>
                <DateInput inputProps={getTextFieldProps('dateBirthIncorporation')}>
                  Date of Birth/Incorporation:*
                </DateInput>
              </Col>
              <Col lg={5}>
                <TextInput inputProps={getTextFieldProps('placeBirthIncorporation')}>
                  Place of Birth/Incorporation:*
                </TextInput>
              </Col>
            </Row>
            <Row>
              <Col lg={5}>
                <DropDown inputProps={getDropdownProps('domicile')} values={getCountries()}>
                  Country of Domicile:*
                </DropDown>
              </Col>
            </Row>
          </FormGroup>
          {getField('investorCategoryType') === 'INDV' ?
            <FormGroup header={'CITIZENSHIP'}>
              <Row>
                <Col lg={5}>
                  <DropDown inputProps={getDropdownProps('nationality')} values={getCountries()}>
                    Nationality:*
                  </DropDown>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <RadioButton inputProps={getRadioButtonProps('usResident')}
                               data={getGenericYesOrNo()} othersOption={false}>
                    Are you a US Resident or US Person:*
                  </RadioButton>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <RadioButton inputProps={getRadioButtonProps('usCitizen')}
                               data={getGenericYesOrNo()} othersOption={false}>
                    Are you a US Citizen:*
                  </RadioButton>
                </Col>
              </Row>
              <Row>
                <Col lg={6}>
                  <RadioButton inputProps={getRadioButtonProps('usResidentCard')}
                               data={getGenericYesOrNo()} othersOption={false}>
                    Do you hold a US Permanent Residence Card:*
                  </RadioButton>
                </Col>
              </Row>
            </FormGroup> : ''}
          {getField('investorCategoryType') === 'CORP' ?
            <FormGroup header={'CORPORATE INFORMATION'}>
              <Row>
                <Col lg={5}>
                  <RadioButton inputProps={getRadioButtonProps('organizationType')}
                               data={getOrganizationType()} othersOption={true}>
                    Type of Organization:*
                  </RadioButton>
                </Col>
              </Row>
              <Row>
                <Col lg={5}>
                  <TextInput inputProps={getTextFieldProps('parentCompany')} placeholder={""}>
                    Name of Parent Organization, if any:
                  </TextInput>
                </Col>
              </Row>
            </FormGroup> : ''}
        </Col>
      </Row>
      <Row className={styles['button-row']}>
        <Col lg={12}>
          <div className={styles['next-button']}>
            <Button onClick={() => nextPage()}>
              NEXT
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default InvestorDetails;
